// Helpers voor de reCAPTCHA v2-widgets (vinkje). Er kunnen er twee op één pagina
// staan (checklist + contact); Google nummert automatisch gerenderde widgets in
// DOM-volgorde, dus de index van de widget is ook zijn id.
const widgetId = (widget) =>
  Array.prototype.indexOf.call(document.querySelectorAll(".g-recaptcha"), widget)

export function recaptchaToken(form) {
  const widget = form.querySelector(".g-recaptcha")
  if (!window.grecaptcha || !widget) return ""
  return window.grecaptcha.getResponse(widgetId(widget))
}

// Tokens zijn eenmalig: na elke poging de widget van dit formulier resetten.
export function resetRecaptcha(form) {
  const widget = form.querySelector(".g-recaptcha")
  if (window.grecaptcha && widget) window.grecaptcha.reset(widgetId(widget))
}

// Stuurt het formulier als JSON naar de Lambda. Geeft { ok, message } terug,
// met de (Nederlandse) melding van de server als die er is.
export async function postForm(endpoint, data) {
  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    })
    const body = await res.json().catch(() => ({}))
    return { ok: res.ok, message: body.message }
  } catch (_) {
    return { ok: false }
  }
}
